import React from 'react';
import {styleCard} from "../styles";
import PatternRect from "../../../images/background/pattern_rect.svg"
import {ProjectCardType} from "../../../axios/api";

const ProjectCard = ({project}: { project: ProjectCardType }) => {
    return (
        <div className={styleCard.card}>
            {project.image && <img src={project.image} className={styleCard.image}/>}
            <div className={styleCard.content}>
                <h3 className={styleCard.title}>{project.title}</h3>
                {project.description && <div className={styleCard.description}
                         dangerouslySetInnerHTML={{__html: project.description}}></div>}
                {styleCard.caption && <span className={styleCard.caption}>{project.caption}</span>}
            </div>
            <img src={PatternRect} className={styleCard.pattern}/>
        </div>
    );
};

export {ProjectCard};